import { push } from "connected-react-router";
import React from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH } from "../../../app/constants";
import { Button } from "../../../components/RegularComponents";

export const IsResidentOfCanada = (props) => {
  const dispatch = useDispatch();

  const title = "Are you a resident of Canada?";

  const handleNext = (isResidentOfCanada) => () => {

    const nextPath = isResidentOfCanada
      ? ROUTE_PATH.MA_IS_NINETEEN
      : ROUTE_PATH.MA_IS_RESIDENT_CANADA_NO;

    dispatch(
      push({
        pathname: `${ROUTE_PATH.MA_APP}${nextPath}`
      })
    );
  };

  return (
    <div className="container">
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{title}</h1>
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2 ">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(true)}
            text={"Yes"}
          />
        </div>

        <div className="col-lg-3">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(false)}
            value={false}
            text={"No"}
          />
        </div>
      </div>
    </div>
  );
};
